const fb = require("../firebase.js");

export default {
  namespaced: true,
  state: {
    sharingActivities: [],
    sharingActivitiesPending: false,
    sharingActivitiesError: null,

    lastDoc: null
  },
  mutations: {
    // sharingActivities
    pushSharingActivities (state, value) {
      state.sharingActivities.push(...value)
    },
    setSharingActivitiesPending (state, value) {
      state.sharingActivitiesPending = value
    },
    setSharingActivitiesError (state, value) {
      state.sharingActivitiesError = value
    },
    // last doc
    setLastDoc (state, value) {
      state.lastDoc = value
    },
  },
  actions: {
    async getFirstSharingActivities({ state, commit, dispatch }){
      if(state.sharingActivities.length > 0) return
      console.log("getFirstSharingActivities")
      commit('setSharingActivitiesPending', true)
      let querySnapshot = await fb.db.collection("sharingActivities").orderBy("createdAt", "desc").limit(6).get()
      dispatch("getSharingActivities", querySnapshot)
    },
    async getNextSharingActivities({ state, commit, dispatch }){
      console.log("getNextSharingActivities")
      commit('setSharingActivitiesPending', true)
      let querySnapshot = await fb.db.collection("sharingActivities").orderBy("createdAt", "desc").limit(6).startAfter(state.lastDoc || 0).get()
      dispatch("getSharingActivities", querySnapshot)
    },
    getSharingActivities({commit}, querySnapshot){
      commit('setLastDoc', querySnapshot.docs[querySnapshot.docs.length - 1])
      if(querySnapshot.empty) commit('setSharingActivitiesPending', false)
      let refs = []
      querySnapshot.forEach((doc) => {
        refs.push(doc.data().ref.path)
      })
      refs = refs.map(ref => fb.db.doc(ref).get())
      Promise.all(refs).then((values) => {
        let sharingActivities = []
        values.forEach((doc) => {
          sharingActivities.push({ id: doc.id, ...doc.data() })
        });
        commit('pushSharingActivities', sharingActivities)
      }).catch((error) => {
        commit('setSharingActivitiesError', error)
        commit('setSharingActivitiesPending', false)
      });
    },   
  }
}
  